import type { CrumbContribution } from './breadcrumbTypes';
import type { ReviewSource } from './reviewSource';
import { readBool } from './urlState';

export type ReviewDocumentMode = 'drawer' | 'focused';

// Whether the review URL is scoped tightly enough for a document crumb to mean
// anything. Only the ACTIVE rail's scope key qualifies: `collection` for the
// production rail, `batch` for the legacy batch rail. The other rail's key is
// deliberately NOT disqualifying — a production review can carry `batch` as a
// subordinate table filter (see the card-source note in breadcrumbTrail), and
// treating it as a rival scope would strip the crumb from an ordinary URL.
export function reviewDocumentMode(search: string, source: ReviewSource): ReviewDocumentMode | null {
  const params = new URLSearchParams(search);
  if (!params.get(source === 'production' ? 'collection' : 'batch')) return null;
  if (readBool(params, 'focused', false)) return 'focused';
  return params.get('docId') ? 'drawer' : null;
}

// A null document is an eligible but not-yet-loaded surface, not proof that no
// document exists — so it still contributes, under a generic label.
export function documentCrumb(doc: { batesId: string } | null): CrumbContribution {
  return { slot: 'document', label: doc?.batesId.trim() ? doc.batesId : 'Document' };
}
